import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { formatDate } from '@angular/common';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { SeriesVisualArgs } from '@progress/kendo-angular-charts';
import { drawing, geometry } from '@progress/kendo-drawing';
import { PhBhpBarChartComponent } from '../ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import { Subject } from 'rxjs';
import { FiltersService } from 'src/app/services/filters.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';

@Component({
  selector: 'lib-ph-bhp-pdf-compliance-multi-filter-check',
  templateUrl: './ph-bhp-pdf-compliance-multi-filter-check.component.html',
  styleUrls: ['./ph-bhp-pdf-compliance-multi-filter-check.component.css']
})

export class PhBhpPdfComplianceMultiFilterCheckComponent implements AfterViewInit, OnInit {
  public repeatHeaders = true;
  @Input() fromComments = false;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;

  @ViewChild('filterDetails') filterDetails;
  @ViewChildren('chartList') chartList;
  @ViewChild('pdf') pdf;
  resultsLoader = new Subject<any>();

  childChartCount: Array<any> = [];
  show1 = false;
  printChart = false;
  roleId;
  range1 = {
    start: new Date(),
    end: new Date()
  }
  maxDate = new Date()
  minDate: Date = void 0;
  showCompareCard = false;
  showFilter = false;
  complianceTitle;
  subStepDetail: boolean;
  isObserve: boolean = false;
  SOPName;
  Steps;
  specificStep;
  filtersData: any[] = [
    {
      setFilterName: null,
      setCountry: null,
      setInstitution: null,
      setWard: null,
      setDepartment: null,
      setCategory: null,
      setSubCategory: null,
      dateRange: [null, null],
      visible: true,
      multiValues: []
    }
  ];
  gridData: Array<any>;
  fields: Array<any>;
  secGridData: Array<any>;
  secFields: Array<any>;
  font = "8px OpenSans-Regular"
  fillWith = '';

  benchmarkFields: Array<any> = [];
  benchmarkFields1: any[] = [];
  benchmarkFields2: any[] = [];
  benchmarkFields3: any[] = [];
  groupedBenchmarkFields1: { name: string, fields: any[] }[] = [];
  groupedBenchmarkFields2: { name: string, fields: any[] }[] = [];
  groupedBenchmarkFields3: { name: string, fields: any[] }[] = [];

  groupedFields: any = {};

  // Multifilters
  results: any[] = [];
  logoSrc = 'assets/img/app-logo.svg';

  constructor(
    public config: AppConfig,
    private changeDetection: ChangeDetectorRef,
    private filtersService: FiltersService,
    private layoutService: PHBHPLayoutPackageService
  ) {
    this.resultsLoader.subscribe((res) => {
      this.results = res;
      setTimeout(() => {
        this.breakCharts();
      }, 500);
      this.changeDetection.detectChanges();
      this.changeDetection.markForCheck();

    });
  }

  showProfessionalSubcategory: boolean = false;

  ngOnChanges() {
  }

  ngOnInit() {
    this.loadLogo();
  }

  ngAfterViewInit() {
    this.checkInstitutionsForProfessionalSubcategory();
    this.subscribeToChartListChanges();
    this.splitFieldsIfNecessary();
  }

  breakCharts() {
    for (let i = 0; i < this.results.length; i++) {
      const result = this.results[i];
      if (!result.resultChart) continue;
      result.charts = this.breakResultChart(result.resultChart);
    }

    setTimeout(() => {
      var chartIndex = 0;
      for (let i = 0; i < this.results.length; i++) {
        const result = this.results[i];
        if (!result.charts) continue;
        for (let j = 0; j < result.charts.length; j++) {
          const chart: any = this.charts.get(chartIndex);
          chart.chartId = result.id;
          chart.font = this.font;
          chart.chartOptions = result.charts[j].chartOptions;
          chart.chartOptions.categoryAxis.categories = result.charts[j].categories;
          chart.chartOptions.series = result.charts[j].series;
          chart.chartOptions.valueAxis.title.font = this.font;
          chart.chartOptions.legend.font = this.font;
          chart.chartOptions.legend.labels = { font: this.font };
          chart.chartOptions.seriesDefaults.visual = (e: SeriesVisualArgs) => {
            const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
            if (colors.includes(e.series.color)) {
              return e.createVisual();
            }

            const benchmarkColor = this.getSeriesColor(e.series.color);
            var left = e.rect.topLeft();
            var right = e.rect.topRight();
            var width = 5;
            var group = new drawing.Group();
            var index = 0;
            for (var x = left.x; x < right.x; x += width) {
              var currentWidth = width;
              if (x + width > right.x) {
                currentWidth = right.x - x;
              }

              var rect = new geometry.Rect([x, left.y], [currentWidth, e.rect.height()])
              var path = drawing.Path.fromRect(rect, { fill: { color: index % 2 == 0 ? benchmarkColor : "#FFFFFF" }, stroke: null });
              group.append(path);
              index = index + 1;
            }

            return group;
          }
          chart.noDataFound = chart.chartOptions.series.length === 0;
          chart.chartDatamani();
          this.charts.toArray()[chartIndex] = chart;
          chartIndex += 1;
        }
      }
    }, 1000);
  }

  breakResultChart(chart) {
    var childChartCount = [];
    const chartOptions = JSON.parse(JSON.stringify(chart.chartOptions));
    const elementsPerChart = this.calculateElementsPerChart(chartOptions.series.length);

    if (chartOptions.series[0].data.length > elementsPerChart) {
      while (chartOptions.series[0].data.length) {
        const newCategoryAxis = chartOptions.categoryAxis.categories.splice(0, elementsPerChart);
        const newSeriesData = chartOptions.series.map((element) => {
          return { ...element, data: element.data.splice(0, elementsPerChart) };
        });

        childChartCount.push({
          chartOptions: JSON.parse(JSON.stringify(chartOptions)),
          categories: newCategoryAxis,
          series: newSeriesData
        });

        if (chartOptions.series[0].data.length != 0 && chartOptions.series[0].data.length <= elementsPerChart) {

          childChartCount.push({
            chartOptions: JSON.parse(JSON.stringify(chartOptions)),
            categories: chartOptions.categoryAxis.categories,
            series: chartOptions.series
          });
          break;
        }
      }
    } else {

      childChartCount.push({
        chartOptions: JSON.parse(JSON.stringify(chartOptions)),
        categories: chartOptions.categoryAxis.categories,
        series: chartOptions.series
      });
    }

    return childChartCount;
  }

    private calculateElementsPerChart(seriesLength: number): number {
    switch (true) {
      case seriesLength >= 4:
        return 10;
      case seriesLength === 3:
        return 12;
      case seriesLength === 2:
        return 13;
      default:
        return 16;
    }
  }

  setComplianceFields(pdfCompliance, colspan, multiColspan?) {
    const getClass = (field: string): string | undefined => {
      if (!field) return undefined;
      const normalized = field.toLowerCase();
      const filterIndex = normalized.lastIndexOf('filter');
      if (filterIndex === -1) return undefined;

      const tail = normalized.slice(filterIndex);
      const match = tail.match(/filter(?:_[^0-9_]*)*_(\d+)/);
      const fallbackMatch = match ?? tail.match(/filter(\d+)/);
      const index = fallbackMatch?.[1];

      return index ? `filter-box-${index}` : undefined;
    };

    pdfCompliance.isMultifilter = false;

    const groupedFields: any = {};
    pdfCompliance.filterHeaders = [];
    pdfCompliance.multiSelectHeaders = [{ title: "", colspan: 1 }];

    pdfCompliance.fields.forEach((item) => {
      if (!groupedFields[item.group]) {
        groupedFields[item.group] = {};
        const filterClass = getClass(item.field);
        pdfCompliance.filterHeaders.push({
          title: item.group,
          colspan: 1,
          filterClass });
      } else {
        pdfCompliance.filterHeaders.find((element) => element.title === item.group).colspan++;
      }

      if (item.multiName) {
        pdfCompliance.isMultifilter = true;
        if (!groupedFields[item.group][item.multiName]) {
          groupedFields[item.group][item.multiName] = [];
          pdfCompliance.multiSelectHeaders.push({ title: item.multiName, colspan: 1, group: item.group });
        } else {
          pdfCompliance.multiSelectHeaders.find((element) => element.title === item.multiName && element.group === item.group).colspan++;
        }
        groupedFields[item.group][item.multiName].push(item);
      } else {
        groupedFields[item.group] = item;
      }
    });

    // group headers and multifilter headers
    const fieldsResult: any[] = [];
    pdfCompliance.filterHeaders.forEach((header: any) => {
      if (header.title !== '') {
        const headerClass = header.filterClass;
        const group = pdfCompliance.fields.filter((el: any) => el.group === header.title);

        let chunk: any[] = [];
        group.forEach((el: any, idx: number) => {
          const fieldWithClass = { ...el, filterClass: headerClass };
          chunk.push(fieldWithClass);

          if ((idx + 1) % colspan === 0 || idx === group.length - 1) {
            fieldsResult.push(chunk);
            chunk = [];
          }
        });
      }
    });

    pdfCompliance.fieldsGroup = fieldsResult;
    pdfCompliance.filterColspan = colspan;

    if (pdfCompliance.isMultifilter) {
      const multiFieldsResult: any[] = [];
      pdfCompliance.filterHeaders.forEach((header: any) => {
        if (header.title !== '') {
          const group = pdfCompliance.multiSelectHeaders.filter(
            (el: any) => el.group === header.title
          );
          let chunk: any[] = [];
          group.forEach((el: any, idx: number) => {
            chunk.push(el);
            if (
              (idx + 1) % (colspan / multiColspan) === 0 ||
              idx === group.length - 1
            ) {
              multiFieldsResult.push(chunk);
              chunk = [];
            }
          });
        }
      });

      pdfCompliance.multiBreaks = multiFieldsResult;
      pdfCompliance.multiColspan = multiColspan;
    }

  }

  checkInstitutionsForProfessionalSubcategory() {
    this.showProfessionalSubcategory = false;

    if (this.filtersService.institutionsList && this.filtersService.institutionsList.length > 0) {
      this.filtersService.institutionsList.forEach((inst) => {
        if (inst.enableProfessionalSubCategory) {
          this.showProfessionalSubcategory = true;
        }
      });
    } else {
      this.filtersService.institutionSubject.subscribe((res) => {
        this.filtersService.institutionsList.forEach((inst) => {
          if (inst.enableProfessionalSubCategory) {
            this.showProfessionalSubcategory = true;
          }
        });
      })
    }
  }

  subscribeToChartListChanges() {
    this.chartList.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        list.font = this.font;
        list.chartOptions = this.childChartCount[index].chartOptions;
        list.chartOptions.categoryAxis.categories = this.childChartCount[index].categories;
        list.chartOptions.series = this.childChartCount[index].series;
        list.chartOptions.valueAxis.title.font = this.font;
        list.chartOptions.legend.font = this.font;
        list.chartOptions.legend.labels = { font: this.font };
        list.chartDatamani();
        list.chart.element.nativeElement.style.height = "400px";
      })
    });
  }

  splitFieldsIfNecessary() {
    this.results.forEach((result) => {
      if (result.fields && result.fields.length > 6) {
        this.splitFields(result);
      }
    });
  }

  setFilters(filters: PhBhpFilterComponent[]) {
    this.filtersData = [];
    filters.forEach((filter, index) => {
      if (!this.filters[index]) {
        this.filtersData[index] = {
          setFilterName: null,
          setCountry: null,
          setInstitution: null,
          setWard: null,
          setDepartment: null,
          setDepartmentType: null,
          setCategory: null,
          setSubCategory: null,
          dateRange: [null, null],
          multiValues: [],
        };
      }

      this.filtersData[index].setFilterName = filter.setFilterName;
      this.filtersData[index].setCountry = filter.setCountry;
      this.filtersData[index].setInstitution = filter.setInstitution;
      this.filtersData[index].setWard = filter.setWard;
      this.filtersData[index].setDepartment = filter.setDepartment;
      this.filtersData[index].setDepartmentType = filter.setDepartmentType;
      this.filtersData[index].setCategory = filter.setCategory;
      this.filtersData[index].setSubCategory = filter.setSubCategory;
      this.filtersData[index].dateRange = [filter.range1.start, filter.range1.end];
      if (filter.showMultiselect) {
        this.filtersData[index].multiSelect = filter.entrySelected.name;
        this.filtersData[index].multiValues = filter.entriesSelectedChips?.map((value) => value.name) || [];
      }

    });
    this.formatDateRanges();
  }

  getSeriesColor(color: string): string {
    const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
    if (colors.includes(color)) {
      return color;
    }

    switch (color) {
      case 'url(#benchmark1)':
        return '#001689'
      case 'url(#benchmark2)':
        return '#40C4FF'
      case 'url(#benchmark3)':
        return '#9744FF'
      case 'url(#benchmark4)':
        return '#BF44B9'
      case 'url(#benchmark5)':
        return '#E57373'
      case 'url(#benchmark6)':
        return '#FFB300'
    }
  }

  splitFields(chart) {
    chart.fields1 = chart.fields.slice(0, 6);
    chart.fields2 = chart.fields.length > 6 ? chart.fields.slice(6) : [];
  }

  formatDateRanges() {
    this.filtersData.forEach(filter => {
      if (filter.dateRange && filter.dateRange.length === 2) {
        const startDate = filter.dateRange[0];
        const endDate = filter.dateRange[1];
        const format = 'dd/MM/yyyy';
        const locale = 'en-GB';
        const formattedStartDate = formatDate(startDate, format, locale);
        const formattedEndDate = formatDate(endDate, format, locale);

        filter.formattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;
      } else {
        filter.formattedDateRange = '';
      }
    });
  }

  toggleVisibility(chartId, serie: any) {
    if (!this.filtersData[serie.index]) return;
    this.filtersData[serie.index].visible = !this.filtersData[serie.index].visible;

    let filteredCharts = this.charts.filter(c => c.chartId === chartId);
    filteredCharts.forEach(chart => {
      chart.internalToggleSerie(serie);
    });
  }

  showFilterData(filterData) {
    if (filterData.visible === undefined) {
      filterData.visible = true;
    }

    return filterData.visible;
  }

  getData(data) {
    return data != null && data != undefined ? data : this.fillWith;
  }

  selectedQuestionnaires: any[] = [];
  selectedQuestionTypes: any[] = [];
  selectedComments: any[] = [];
  getSelectedQuestionnaires() {
    var questionnaireNames = [];
    this.selectedQuestionnaires.forEach((questionnaire) => {
      if (questionnaire.questionnaireName == "CHECK.EVALUATION.ALL_QUESTIONNAIRES") {
        questionnaireNames.push("CHECK.EVALUATION.ALL_QUESTIONNAIRES");
      } else {
        questionnaireNames.push(`${questionnaire.questionnaireName} | ${questionnaire.institutionName}`);
      }
    });

    return questionnaireNames.join(', ');
  }

  getSelectedQuestionTypes() {
    return this.selectedQuestionTypes.join(', ');
  }

  getSelectedComments() {
    return this.selectedComments.join(', ');
  }

  hasMultipleFilters(): boolean {
    const visibleFiltersCount = this.filtersData ?
      this.filtersData.filter(filter => filter && filter.visible !== false).length : 0;
    return visibleFiltersCount >= 4;
  }

  private loadLogo(): void {
    this.layoutService.getAppLogoBase64()
      .then((logo) => {
        if (!logo) {
          return;
        }

        this.logoSrc = logo;
        this.changeDetection.markForCheck();
      })
      .catch(() => {
        // Keep default asset path fallback if conversion fails
        this.logoSrc = 'assets/img/app-logo.svg';
        this.changeDetection.markForCheck();
      });
  }
}
